/** @jsxImportSource @emotion/react */
import { Button, FormControl, TextField, Select, Stack, ButtonGroup, MenuItem, InputLabel, DialogContent,Link,CircularProgress, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, Snackbar, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery, useTheme, OutlinedInput, Divider } from '@mui/material';
import { useFormik } from 'formik';
import { useContext, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import * as yup from 'yup';
import { useEffect } from 'react';
import { StyledTextField } from '../../Components/CustomTextfield';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { addStageData, updateStepper } from '../../Helper/Redux/reducers/upDown';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { detailChecker, steps, getGlobalSteper } from '../../Helper/AppStepperData';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import { Verified } from '@mui/icons-material';
import FullScreenLoader from '../../Components/FullScreenLoader';
import TextLoader from '../../Components/TextLoader';
import { getObjections, objectionNavigation, setObjections } from '../../Helper/Functions';

var isEmailVerified;
var isMobileVerified;
var oldValue = {emailRelation:"", mobileRelation:""};
function Profile(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const [snackBarOpen, setSnackBarOpen] = useState(false)
    const [responseStatus, setResponseStatus] = useState({})
    const [isEdit, setIsEdit] = useState(false)
    const [options, setOptions] = useState([])
    const [openProfilePhonePopup, setOpenProfilePhonePopup] = useState(false)
    const [openProfileEmailPopup, setOpenProfileEmailPopup] = useState(false)
    const [otp, setOtp] = useState({ contactotp: "", emailotp: "" })
    const [isVerificationLinkSent, setIsVerificationLinkSent] = useState(false)
    const [loading, setLoading] = useState(false)
    const [loader, setLoader] = useState(false)
    const [kRAData, setKRAData] = useState({})
    const navigate = useNavigate()
    const [objectionState, setObjectionState] = useState({ "isObjection": false, "objections": [] })
    const localeText = useContext(Il8nContext)
    const [generateLink, setGenerateLink] = useState()
    const [refresh,setRefresh] = useState(false)
    const [dataState, setDataState] = useState("Father")
    const [stageData,setStageData] = useState(null)
    useEffect(() => {
        // initialPersonalDetailsValues(JSON.parse(localStorage.getItem("personalDetails")))
        getContactVerificationDetails()
        getContactRelationOptions()
        getStageDetails()

        let objectionValue = getObjections()
        let objections = objectionValue?.filter(objection => objection.navigationPath == "/Profile")

        if (objections?.length > 0) {
            objections = objections.map(objection => {
                return {
                    "objectionDescription": objection.objectionDescription,
                    "remark": objection.remark
                }
            })

            objectionValue = objectionValue.map(objection => {
                if (objection.navigationPath == "/Profile") {
                    objection.isNavigationDone = true;
                }
                return objection
            })

            setObjections(objectionValue)
            setObjectionState({ isObjection: true, objections })
        }
    }, [])

    useEffect(() => {
        initialPersonalDetailsValues()
    }, [kRAData])

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    setStageData(resp?.data?.success)
                    !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                    if (detailChecker(resp.data.success.stageDetilasList, 6)) {
                        getPersonalDetails()
                    }
                    else {
                        getKRADetails()
                    }
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

    const initialPersonalDetailsValues = (values) => {
        // ["fName","mName","lName","faFName","fmFName","flFName","gender","marStatus","email","mobile","emailRelation","mobileRelation"]
        if (values || Object.keys(kRAData).length > 0) {
            formik.setValues({
                firstName: values && values.clientFirstName || kRAData.fName,
                middleName: values && values.clientMiddleName || kRAData.mName,
                lastName: values && values.clientLastName || kRAData.lName,
                gender: values && values.gender || kRAData.gender || "Male",
                relation: values && values.relation || "Father",
                relationFirstName: values && values.relationFirstName || kRAData.faFName,
                relationMiddleName: values && values.relationMiddleName || kRAData.fmFName,
                relationLastName: values && values.relationLastName || kRAData.flFName,
                maritalStatus: values && values.maritalStatus || kRAData.marStatus || "Single",
                mobileNumber: values && values.mobile || kRAData.mobile,
                mobileRelation: values && values.mobileRelation || kRAData.mobileRelation,
                emailId: values && values.email || kRAData.email,
                emailIdRelation: values && values.emailRelation || kRAData.emailRelation,
                emailVerified: values && values.emailVerified || "N", // hardcoed in DIY
                mobileVerified: values && values.mobileVerified || "Y" // hardcoed in DIY
            })
            isEmailVerified = values && values.emailVerified || kRAData && kRAData.emailVerified || "N"
            isMobileVerified = values && values.mobileVerified || kRAData && kRAData.mobileVerified || "N"
            oldValue.emailRelation = values && values.emailVerified  === 'Y' && values && values.emailRelation || kRAData.emailRelation
            oldValue.mobileRelation = values && values.emailVerified  === 'Y' &&  values && values.mobileRelation || kRAData.mobileRelation
        }
    }

    const getPersonalDetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getPersonalDetails).then(resp => {
            if (resp.data.success) {
                setLoading(false)
                initialPersonalDetailsValues(resp.data.success[0])
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            setLoading(false)
            console.log(err.message)
        })
    }

    const getContactRelationOptions = () => {
        axios.get(process.env.REACT_APP_API_URL + config.relationOptions).then(resp => {
            if (resp.data.success) {
                setOptions(resp.data.success)
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            console.log(err.message)
        })
    }

    const getContactVerificationDetails = () => {
        // setLoader(true)
        setRefresh(true)
        axios.get(process.env.REACT_APP_API_URL + config.contactVerification).then(resp => {
            if (resp.data.success) {
                dispatch(addStageData({ ...store, ...resp.data.success }))
                // setLoader(false)
                setRefresh(false)
                isEmailVerified = resp.data.success.emailVerified ?'Y' : 'N'
                isMobileVerified = resp.data.success.mobileVerified ?'Y' : 'N'
                formik.setFieldValue("emailVerified", resp.data.success.emailVerified ?'Y' : 'N')
                formik.setFieldValue("mobileVerified", resp.data.success.mobileVerified ?'Y' : 'N')
                oldValue.emailRelation = resp.data.success.emailVerified && formik.values.emailIdRelation
                oldValue.mobileRelation = resp.data.success.mobileVerified && formik.values.mobileRelation
            }
            else {
                // setLoader(false)
                setRefresh(false)
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            console.log(err.message)
        })
    }

    const getKRADetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getKRA).then(resp => {
            // axios.get("https://demo0773011.mockable.io/test").then(resp => {
                // axios.get("https://caac7f70-ffa5-4d43-b395-3ca2b7209664.mock.pstmn.io").then(resp => {
            setLoading(false)
            if (resp.data.success) {
                //initialPersonalDetailsValues(resp.data.success)
                dispatch(addStageData({ ...store, isKRAVerified: resp.data.success.isKRAVerified }))
                setKRAData(resp.data.success)
                // setIsEdit(!resp.data.success.isKRAVerified)
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            setLoading(false)
            // obj && obj.complete && obj.complete();
            // errorEvent.sendMessage({type:"error",data:err.message})
            console.log(err.message)
        })
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const validationSchema = yup.object({
        firstName: yup
            .string('')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.signUpEnterValidName)
            .required(localeText?.profileFirstNameRequired),
        middleName: yup
            .string('')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.signUpEnterValidName),
        lastName: yup
            .string('')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.signUpEnterValidName),
            // .required(localeText?.profileLastNameRequired),
        gender: yup
            .string('')
            .nullable()
            .required(localeText?.profileGenderRequired),
        relation: yup
            .string('')
            .required(localeText?.profileRelationRequired),
        relationFirstName: yup
            .string('')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.signUpEnterValidName)
            .required(localeText?.profileFirstNameRelationRequired),
        relationMiddleName: yup
            .string('')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.signUpEnterValidName),
        relationLastName: yup
            .string('')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.signUpEnterValidName),
            // .required(localeText?.profileLastNameRelationRequired),
        maritalStatus: yup
            .string('')
            .nullable()
            .required(localeText?.profileMaritalStatusRequired),
        mobileNumber: yup
            .number('')
            .required(localeText?.profileMobileNumberRequired)
            .typeError(localeText?.loginInvalidNo),
        mobileRelation: yup
            .string('')
            .required(localeText?.profileMobileRelationRequired),
        emailId: yup
            .string('')
            .email(localeText?.profileValidEmail)
            .required(localeText?.signUpEmailRequired),
        emailIdRelation: yup
            .string('')
            .required(localeText?.profileEmailRelationRequired),
    });

    const nextNavigation = () => {
        if (objectionState.isObjection) {
            objectionNavigation(navigate)
        }
        else {
            dispatch(updateStepper({ step: 2, nestedStep: 1 }));
            navigate("/AddressDetails")
        }
    }

    const formik = useFormik({
        initialValues: {
            firstName: '',
            middleName: "",
            lastName: "",
            gender: "Male",
            relation: "Father",
            relationFirstName: "",
            relationMiddleName: "",
            relationLastName: "",
            maritalStatus: "Single",
            mobileNumber: '',
            mobileRelation: "",
            emailId: "",
            emailIdRelation: "",
            motherFirstName: "",
            motherMiddleName: "",
            motherLastName: "",
            emailVerified: "N", // hardcoed in DIY
            mobileVerified: "Y" // hardcoed in DIY
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setLoading(true)
            var dataObj = {}

            dataObj.clientFirstName = values.firstName?.toUpperCase()
            dataObj.clientMiddleName = values.middleName?.toUpperCase()
            dataObj.clientLastName = values.lastName?.toUpperCase()

            dataObj.relationFirstName = values.relationFirstName?.toUpperCase()
            dataObj.relationMiddleName = values.relationMiddleName?.toUpperCase() || ""
            dataObj.relationLastName = values.relationLastName?.toUpperCase()

            dataObj.maidenFirstName = ""
            dataObj.maidenMiddleName = ""
            dataObj.maidenLastName = ""

            dataObj.gender = values.gender
            dataObj.maritalStatus = values.maritalStatus
            dataObj.relation = values.relation

            dataObj.clientNamePrefix = dataObj.gender === "Male" ? "Mr" : (dataObj.maritalStatus === "Married" || dataObj.maritalStatus === "Widow") ? "Mrs" : "Miss"
            dataObj.relationNamePrefix = dataObj.relation === "Spouse" ? (dataObj.gender === "Female" ? "Mr" : "Mrs") : "Mr"
            dataObj.maidenNamePrefix = "Mrs"
            dataObj.email = values.emailId
            dataObj.mobile = values.mobileNumber
            dataObj.emailRelation = values.emailIdRelation
            dataObj.mobileRelation = values.mobileRelation
            // dataObj.mobileVerified = values.mobileVerified
            console.log(dataObj)
            axios.post(process.env.REACT_APP_API_URL + config.personalDetails, dataObj).then(resp => {
                setLoading(false)
                if (resp.data.success) {
                    // window.open(`${window.location.origin}${"/AddressDetails"}`, "_self")
                    nextNavigation()
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((error) => {
                setLoading(false)
                setResponseStatus({ "message": error.message, "type": "error" })
                setSnackBarOpen(true)
            })
        },
    });

    const getContactVarification = () => {
        setLoading(true)
        const payload = {
            email: "",
            emailRelation: "",
            holder: "1",
            mobile: formik.values.mobileNumber,
            mobileRelation: formik.values.mobileRelation,
            product: "PersonalDetails"
        }
        axios.post(process.env.REACT_APP_API_URL + config.validationRelation, payload)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    setResponseStatus({ "message": localeText?.profileOtpHas, "type": "success" })
                    setSnackBarOpen(true)
                    setOpenProfilePhonePopup(!openProfilePhonePopup)
                }
                else {
                    setLoading(false)
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }



    const sendEmailVerificationLink = () => {
        setLoader(true)
        const payload = {
            email: formik.values.emailId,
            emailRelation: formik.values.emailIdRelation,
            holder: "1",
        }
        axios.post(process.env.REACT_APP_API_URL + config.verifyEmail, payload)
            .then(resp => {
                if (resp.data.success) {
                    setIsVerificationLinkSent(true)
                    setLoader(false)
                    setResponseStatus({ "message": localeText?.profileVerificationLink, "type": "success" })
                    setSnackBarOpen(true)
                } else {
                    setLoader(false)
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const handleContactVarification = (e) => {
        getContactVarification();
    }

    const handleCloseContactVarification = () => {
        setOpenProfilePhonePopup(!openProfilePhonePopup)
        setOtp({ ...otp, contactotp: "" });
    }


    const handleEmailVarification = (e) => {
        sendEmailVerificationLink()
    }

    const contactVarification = () => {
        console.log('OTP', otp.contactotp.length)
        if (otp.contactotp.length == 6) {
            const payload = {
                email: "",
                emailRelation: "",
                holder: "1",
                mobile: formik.values.mobileNumber,
                mobileRelation: formik.values.mobileRelation,
                otp: otp.contactotp,
                product: "PersonalDetails"
            }
            axios.post(process.env.REACT_APP_API_URL + config.verifyOtp, payload)
                .then(resp => {
                    if (resp.data.success) {
                        setSnackBarOpen(true)
                        setOpenProfilePhonePopup(!openProfilePhonePopup)
                        setOtp({ ...otp, contactotp: "" });
                        setResponseStatus({ "message": localeText?.profileVerifiedSuccessfully, "type": "success" })
                        dispatch(addStageData({ ...store, mobileVerified: true }))
                        formik.setFieldValue("mobileVerified", 'Y')
                        isMobileVerified = 'Y'
                        oldValue.mobileRelation = formik.values.mobileRelation
                    } else {
                        throw new Error(resp.data.error)
                    }
                }).catch((err) => {
                    setResponseStatus({ "message": err.message, "type": "error" })
                    setSnackBarOpen(true)
                })
        } else {
            setResponseStatus({ "message": localeText?.profileValid, "type": "error" })
            setSnackBarOpen(true)
        }

    }

    const handleInput = (e) => {

        let name, value;
        name = e.target.name
        value = e.target.value

        setOtp({ ...otp, [name]: value });
    }

    const handleEmailChange = (e) => {
        setIsVerificationLinkSent(false)
        dispatch(addStageData({ ...store, emailVerified: false }))
        formik.setFieldValue("emailVerified", 'N')
        isEmailVerified = 'N'
    }

    const handleEmailSelectChange = (e) => {
        setIsVerificationLinkSent(false)
        dispatch(addStageData({ ...store, emailVerified: false }))
        formik.setFieldValue("emailVerified", 'N')
        isEmailVerified = (e.target.value === oldValue.emailRelation) ? 'Y' : 'N'
    }

    const handleMobileChange = (e) => {
        dispatch(addStageData({ ...store, mobileVerified: false }))
        formik.setFieldValue("mobileVerified", 'N')
        isMobileVerified = 'N'
    }
    const handleMobileSelectChange = (e) => {
        setIsVerificationLinkSent(false)
        dispatch(addStageData({ ...store, mobileVerified: false }))
        formik.setFieldValue("mobileVerified", 'N')
        isMobileVerified =  (e.target.value === oldValue.mobileRelation) ? 'Y' : 'N'
    }

    const generateEmailLink = () => {
        getContactVerificationDetails()
        setGenerateLink(true)
    }
    useEffect(()=>{
    }, [dataState])
    // console.log(dataState, 'dataState')
    // const handleChanges = (value) =>{
    //     formik.setFieldValue("relation","Father") ?  formik.setFieldValue("maritalStatus", console.log(value, 'value') || "") : formik.setFieldValue("maritalStatus", console.log("Married", 'value'))}
  
    return (
        <>
            <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
                <PageLayout css={{ overflowY: "scroll" }} showSidebar isObjectionScreen={objectionState.isObjection}
                    breadcrumb={{ show: true, steps: steps[1].nestedSteps, step: 2, nestedStep: 1 }}>
                    <ElevatedGrid >
                        <Grid container item xs={12} lg={12} md={12} alignItems={"start"} spacing={3}>

                            <Grid container item alignItems={"center"}>
                                {objectionState.isObjection && <Grid item xs={12} css={{ padding: "10px", color: "white", backgroundColor: "lightcoral", borderRadius: "10px", margin: "10px 0px" }}>
                                    {objectionState.objections.map((objection, i) =>
                                        <>
                                            <Typography align="center" display="inline" variant="body2" fontWeight={"bold"}>
                                            {localeText?.profileObjection} {objection.objectionDescription || "--"} {localeText?.profileObjectionRemark} {objection.remark || "--"} <br />
                                            </Typography>
                                            {i > 0 && <Divider />}
                                        </>
                                    )}
                                </Grid>}
                                <Grid item >
                                    <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                        {"PROFILE"}
                                    </Typography>
                                </Grid>
                                {stageData && stageData?.accountOpeningType != "DIGI" &&
                                <Grid item css={{ paddingLeft: "20px" }}>
                                    <div css={{ backgroundColor: (stageData?.accountOpeningType == "KRA") ? "#64A93B" : "#D67D7D", borderRadius: "20px", padding: "5px 15px", display: "flex" }}>
                                        {(stageData?.accountOpeningType == "KRA") ?
                                            <>
                                                <img src="images/icon_KRA_verified.svg" alt="icon_KRAVerified" css={{ height: "20px", width: "20px", alignSelf: "center", marginRight: "5px" }} />
                                                <Typography display={"inline"} css={{ color: "white", fontSize: "small" }}>
                                                    {localeText?.profileKRAverified}
                                                </Typography>
                                            </>
                                            : <>
                                                <img src="images/icon_KRA_Not_Verified.svg" alt="icon_KRANotVerified" css={{ height: "20px", width: "20px", alignSelf: "center", marginRight: "5px" }} />
                                                <Typography display={"inline"} css={{ color: "white", fontSize: "small" }}>
                                                    {localeText?.profileKRAnotVerified}
                                                </Typography>
                                            </>
                                        }
                                    </div>
                                </Grid>}
                                {/* <Grid item css={{ marginLeft: "auto" }}>
                                    {isEdit ? <img src="images/icon_close_black.svg" alt="edit" css={{ cursor: "pointer" }} onClick={() => { formik.resetForm(); setIsEdit(!isEdit) }} /> : <img src="images/edit.svg" alt="edit" css={{ cursor: "pointer" }} onClick={() => setIsEdit(!isEdit)} />}
                                </Grid> */}
                            </Grid>

                            <Grid container item xs={12} lg={8} md={12} spacing="12" css={{ marginTop: "5px" }}>
                                <Grid item xs={12} css={{ fontWeight: "bold" }}>
                                {localeText?.profileOtpYourName}
                                </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    <StyledTextField id="firstName" name="firstName" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        // required
                                        value={(formik.values.firstName)?.toUpperCase()}
                                        error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                        helperText={formik.touched.firstName && formik.errors.firstName} fullWidth
                                        label={localeText?.profileFirstName} variant="outlined"
                                        // disabled/* ={!isEdit} */
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    <StyledTextField id="middleName" name="middleName" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={(formik.values.middleName)?.toUpperCase()}
                                        error={formik.touched.middleName && Boolean(formik.errors.middleName)}
                                        helperText={formik.touched.middleName && formik.errors.middleName} fullWidth
                                        label={localeText?.profileMiddleName} variant="outlined"
                                        // disabled/* ={!isEdit} */
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    <StyledTextField id="lastName" name="lastName" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        // required
                                        value={(formik.values.lastName)?.toUpperCase()}
                                        error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                        helperText={formik.touched.lastName && formik.errors.lastName} fullWidth
                                        label={localeText?.profileLastName} variant="outlined"
                                        // disabled/* ={!isEdit} */
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item xs={12} lg={4} md={8} spacing="12" css={{ marginTop: "6px" }}>
                                <Grid item xs={12} css={{ fontWeight: "bold" }}>{localeText?.profileOtpGender} *</Grid>
                                <Grid item xs={12} css={{ textTransform: "none" }}>
                                    <FormControl error={formik.touched.gender && Boolean(formik.errors.gender)} >
                                        <ToggleButtonGroup
                                            value={formik.values.gender}
                                            exclusive
                                            id="gender"
                                            name="gender"
                                            /* disabled={!isEdit} */
                                            onChange={(e, value) => { formik.setFieldValue("gender", value) }}
                                            color="primary"
                                            css={{ marginTop: "6px" }}
                                        >
                                            <ToggleButton value="Male" css={{ textTransform: "none", padding: "8px" }}>
                                                {localeText?.profileMale}
                                            </ToggleButton>
                                            <ToggleButton value="Female" css={{ textTransform: "none", padding: "8px" }}>
                                                {localeText?.profileFemale}
                                            </ToggleButton>
                                            <ToggleButton value="Transgender" css={{ textTransform: "none", padding: "8px" }}>
                                                {localeText?.profileTransgender}
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                        <FormHelperText>{formik.touched.gender && formik.errors.gender}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container item xs={12} lg={8} md={12} spacing="12" css={{ marginTop: "5px" }}>
                                <Grid container item xs={12} spacing={3}>
                                    <Grid item css={{ fontWeight: "bold", alignSelf: "center" }}>
                                    {localeText?.profileOtpRelation}
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl id="relation" name="relation" /* disabled={!isEdit} */ error={formik.touched.relation && Boolean(formik.errors.relation)}>
                                            <RadioGroup value={formik.values.relation} row name="row-radio-buttons-group" onChange={(e, value) => { formik.setFieldValue("relation", value, setDataState(value)) }}>
                                                <FormControlLabel value="Father" control={<Radio size='small' />} label={localeText?.profileFather} />
                                                <FormControlLabel value="Spouse" control={<Radio size='small' />} label={localeText?.profileSpouse} />
                                            </RadioGroup>
                                            <FormHelperText>{formik.touched.relation && formik.errors.relation}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    <StyledTextField id="relationFirstName" name="relationFirstName" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        // required
                                        value={(formik.values.relationFirstName)?.toUpperCase()}
                                        error={formik.touched.relationFirstName && Boolean(formik.errors.relationFirstName)}
                                        helperText={formik.touched.relationFirstName && formik.errors.relationFirstName} fullWidth
                                        label={localeText?.profileFirstName} variant="outlined"
                                        // disabled={!isEdit}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    <StyledTextField id="relationMiddleName" name="relationMiddleName" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={(formik.values.relationMiddleName)?.toUpperCase()}
                                        error={formik.touched.relationMiddleName && Boolean(formik.errors.relationMiddleName)}
                                        helperText={formik.touched.relationMiddleName && formik.errors.relationMiddleName} fullWidth
                                        label={localeText?.profileMiddleName} variant="outlined"
                                        // disabled={!isEdit}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    <StyledTextField id="relationLastName" name="relationLastName" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        // required
                                        value={(formik.values.relationLastName?.toUpperCase())}
                                        error={formik.touched.relationLastName && Boolean(formik.errors.relationLastName)}
                                        helperText={formik.touched.relationLastName && formik.errors.relationLastName} fullWidth
                                        label={localeText?.profileLastName} variant="outlined"
                                        // disabled={!isEdit}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item xs={12} lg={4} md={12} spacing="12" css={{ marginTop: "6px", alignSelf: "flex-end" }}>
                                <Grid item xs={12} css={{ fontWeight: "bold" }}>
                                {localeText?.profileOtpMaritalStatus} *
                                </Grid>
                                <Grid item xs={12} css={{ textTransform: "none" }}>
                                    <FormControl error={formik.touched.maritalStatus && Boolean(formik.errors.maritalStatus)}>
                                        <ToggleButtonGroup
                                            value={dataState != "Father" ? (formik?.values?.maritalStatus?.replace("Single" , "Married")) : formik.values.maritalStatus}
                                            exclusive
                                            id="maritalStatus"
                                            name="maritalStatus"
                                            // disabled={!isEdit}
                                            onChange={(e, value) => {formik.setFieldValue("maritalStatus", value)}}
                                            color="primary"
                                            css={{ marginTop: "6px" }}
                                        >
                                            <ToggleButton value="Single" css={{ textTransform: "none", padding: "8px" }}>
                                               {localeText?.profileSingle}
                                            </ToggleButton>
                                            <ToggleButton value="Married" css={{ textTransform: "none", padding: "8px" }}>
                                                {localeText?.profileMarried }
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                        <FormHelperText>{formik.touched.maritalStatus && formik.errors.maritalStatus}</FormHelperText>
                                    </FormControl>

                                </Grid>
                            </Grid>

                            <Grid container item xs={12} spacing="12" css={{ marginTop: "5px" }}>
                                <Grid item xs={12} css={{ fontWeight: "bold", alignSelf: "center" }}>
                                    {localeText?.profileOtpContactDetails}
                                </Grid>
                                <Grid item xs={12} md={6} lg={2.5}>
                                    <StyledTextField id="mobileNumber" name="mobileNumber" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formik.values.mobileNumber}
                                        error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                                        helperText={formik.touched.mobileNumber && formik.errors.mobileNumber} fullWidth
                                        label={localeText?.profileMobileNo} variant="outlined"
                                        inputProps={{ maxLength: 10 }}
                                        min={0}
                                        // required
                                        onChange={(e) => {
                                            handleMobileChange(e)
                                            formik.handleChange(e)
                                        }
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={3} sx={{ display: "flex" }}>
                                    <FormControl /* disabled={!isEdit} */ required fullWidth error={formik.touched.mobileRelation && Boolean(formik.errors.mobileRelation)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.profileMobileNoRelation}
                                        </InputLabel>
                                        <Select
                                            id="mobileRelation"
                                            name="mobileRelation"
                                            value={formik.values.mobileRelation}
                                            size="small"
                                            // required
                                            onChange={(e) => {
                                                handleMobileSelectChange(e)
                                                formik.handleChange(e)
                                            }
                                            }
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.profileMobileNoRelation}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{"- Select value -"}</MenuItem>
                                            {options.filter(opt => opt.relationType == "Mobile").map(opt => <MenuItem value={opt.relationship}>{opt.relationship}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.mobileRelation && formik.errors.mobileRelation}</FormHelperText>
                                        {isMobileVerified === 'Y' ?
                                        <Typography variant="body2"><CheckCircleOutlineIcon css={{ color: "green", verticalAlign: "middle" }} />{localeText?.profileVerified}</Typography> :
                                         <Typography variant="body2" ><HighlightOffIcon css={{ color: "red", verticalAlign: "middle" }} />{localeText?.profileUnverified}</Typography>}
                                    </FormControl>
                                    {
                                        <Grid item css={{ marginTop: "13px", marginLeft: "5px", fontSize: "12px", paddingBottom: "30px" }}>
                                            <Button variant='contained' color="secondary" sx={{ fontSize: "12px" }}
                                                disabled={ isMobileVerified === 'Y' || !formik.values.mobileRelation } onClick={handleContactVarification}>
                                                {localeText?.profileVerify}
                                            </Button>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid item xs={12} md={6} lg={2.5}>
                                    <StyledTextField id="emailId" name="emailId" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formik.values.emailId}
                                        error={formik.touched.emailId && Boolean(formik.errors.emailId)}
                                        helperText={formik.touched.emailId && formik.errors.emailId} fullWidth
                                        label={localeText?.profileEmailId} variant="outlined"
                                        // required
                                        // disabled={!isEdit}
                                        onChange={(e) => {
                                            handleEmailChange()
                                            formik.handleChange(e)
                                        }
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={3} sx={{ display: "flex" }}>
                                    <FormControl /* disabled={!isEdit} */ required fullWidth error={formik.touched.emailIdRelation && Boolean(formik.errors.emailIdRelation)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.profileEmailNoRelation}
                                        </InputLabel>
                                        <Select
                                            id="emailIdRelation"
                                            name="emailIdRelation"
                                            value={formik.values.emailIdRelation}                         
                                            size="small"
                                            onChange={(e) => {
                                                handleEmailSelectChange(e)
                                                formik.handleChange(e)
                                            }
                                            }
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.profileEmailNoRelation}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{"- Select value -"}</MenuItem>
                                            {options.filter(opt => opt.relationType == "Email").map(opt => <MenuItem value={opt.relationship}>{opt.relationship}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.emailIdRelation && formik.errors.emailIdRelation}</FormHelperText>
                                        {(isEmailVerified === 'Y') ?
                                        <Typography variant="body2"><CheckCircleOutlineIcon css={{ color: "green", verticalAlign: "middle" }} />{localeText?.DigiLockerKYCVerificationVerified}</Typography> 
                                        : isVerificationLinkSent
                                        ? <Typography variant="body2" color="secondary">{localeText?.profileCheckMailBox}</Typography> 
                                        : <Typography variant="body2"><HighlightOffIcon css={{ color: "red", verticalAlign: "middle" }} />{localeText?.profileUnverified}</Typography>}
                                    </FormControl>
    
                                    {
                                        isVerificationLinkSent ?
                                            <Grid item css={{ marginTop: "13px", marginLeft: "5px", fontSize: "12px", display: isEmailVerified === 'Y' && "none"}}>
                                                <Button variant='contained' color="secondary" sx={{ fontSize: "12px" }}  onClick={generateEmailLink}>
                                                    {
                                                        refresh ? <CircularProgress size={20} sx={{color: 'white'}}/> : localeText?.profileRefresh
                                                    }
                                                </Button>
                                                {
                                                    generateLink &&
                                                    <Typography css={{ cursor: "pointer", fontSize: "14px", textAlign: "center", marginTop: "8px", color: "#24B7CC" }}>
                                                        {loader ? <TextLoader name={localeText?.profileLoading} /> : <Link onClick={handleEmailVarification}>{localeText?.profileVerifyEmail}</Link>}
                                                    </Typography>
                                                }

                                            </Grid>
                                            :
                                            <Grid item css={{ marginTop: "13px", marginLeft: "5px", fontSize: "12px" }}>
                                                <Button variant='contained' color="secondary" sx={{ fontSize: "12px" }}
                                                    disabled={ isEmailVerified === 'Y' || !formik.values.emailIdRelation } onClick={handleEmailVarification}>
                                                    {
                                                         loader ? <CircularProgress size={20} sx={{color: 'white'}}/> : localeText?.profileVerify
                                                    }
                                                </Button>
                                            </Grid>
                                    }
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item css={{ marginTop: "40px" }}>
                            <Button type="submit" variant='contained' color="secondary">
                             {localeText?.profileSave}
                            </Button>
                        </Grid>

                    </ElevatedGrid>
                </PageLayout>
            </form>
            {loading && <FullScreenLoader />}
            {
                <Popup
                    open={openProfilePhonePopup}
                    maxWidth={"sm"}
                >
                    <PopupTitle onClose={handleCloseContactVarification} />
                    <DialogContent css={{ textAlign: "center", margin: "0px 40px" }}>
                        <Typography css={{ marginBottom: "10px", fontSize: "12px", color: "#24B7CC" }}>
                            {localeText?.profileSend}
                        </Typography>
                        <TextField
                            hiddenLabel
                            id="filled-hidden-label-small"
                            InputProps={{ disableUnderline: true }}
                            variant="filled"
                            size="small"
                            sx={{ width: "70%" }}
                            name="contactotp"
                            inputProps={{ maxLength: 6 }}
                            // required
                            value={otp.contactotp}
                            onChange={handleInput}
                        />
                        {!loader && <div css={{ textAlign: "center", margin: "5px 0px 15px 0px" }}>
                            <Typography variant='caption' css={{ textDecoration: "underline", color: "#24B7CC", cursor: "pointer" }} disabled={loader} onClick={getContactVarification}>
                                {localeText?.profileOtp}
                            </Typography>
                        </div>}
                        <div css={{ textAlign: "center", margin: "5px 0px 15px 0px", color: "#24B7CC" }}>
                            {loader && <TextLoader name='Sending' />}
                        </div>

                        <Stack spacing={2} direction="row" css={{ marginLeft: "12px" }}>
                            <Button variant='outlined' color="secondary" css={{ width: "115px" }} onClick={handleCloseContactVarification}>
                                {"Back"}
                            </Button>

                            <Button variant='contained' color="secondary" css={{ width: "115px" }} onClick={contactVarification}>
                                {"Submit"}
                            </Button>
                        </Stack>


                    </DialogContent>
                </Popup>
            }
            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default Profile;
